import { render } from "./ZhaiCommentPC.vue?vue&type=template&id=f1c5b4c6&scoped=true"
import script from "./ZhaiCommentPC.vue?vue&type=script&lang=js"
export * from "./ZhaiCommentPC.vue?vue&type=script&lang=js"

import "./ZhaiCommentPC.vue?vue&type=style&index=0&id=f1c5b4c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c5b4c6"]])

export default __exports__